import src from "IMAGE";
export default { src, width: 158, height: 38, blurWidth: 0, blurHeight: 0};
